export default __webpack_public_path__ + "static/media/logo-six-show.637ba23c.png";